import PropTypes from 'prop-types';

export default function Wrapper({ children, step }) {
	return (
		<div className="prc" data-step={step}>
			{children}
		</div>
	);
}

Wrapper.propTypes = {
	children: PropTypes.node.isRequired,
	step: PropTypes.number.isRequired,
};
